<template>
    <div id="apart-init" @click.self="show">
        <Modal :visible.sync="showModal">
            <!-- <template #header>
        <h2>自定义头部</h2>
      </template>
-->
            <main class="main-vip">
                <img src="@/assets/image/modal-close.png" class="close-icon cursor_1" @click.stop="handleClose" />
                <img src="@/assets/image/apart/apart_vip_dialog.png" width="611" height="525" />
                <div class="vip-btn" @click.stop="toPage"><span>立即开通VIP会员</span></div>
            </main>

            <!-- <template #footer>
        <button @click.stop="handleClose">取消</button>
        <button @click.stop="confirmAction">确定</button>
      </template> -->
        </Modal>
    </div>
</template>
<script>
import api from '@/api/api';
import Modal from '@/components/Modal.vue'
import { EventBus } from '@/utils/eventBus';
export default {
    components: {
        Modal
    },
    props: {
        user: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    methods: {
        show() {
            if (!Object.keys(this.user).length) {
                EventBus.$emit('openLogin')
            } else {
                if (!this.user.vip) {
                    this.showModal = true
                } else {
                    this.$emit("toAdd", 'list')
                }
            }

        },
        handleClose() {
            console.log('弹窗关闭');
            this.showModal = false
        },
        toPage() {
            this.showModal = false
            this.$emit('openVip')
            // setTimeout(() => {
            //     EventBus.$emit('openVip')
            // }, 0);
        }
    }
}
</script>
<style scoped>
#apart-init {
    flex: 1;
    overflow: hidden;
    background-image: url('@/assets/image/apart/apart_init.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: left; 
    cursor: pointer;
    border-radius: 10px;
    margin: 16px 20px 0 20px;;
}

.main-vip {
    position: relative;
    border-radius: 48px;
    overflow: hidden;
}

.close-icon {
    width: 37px;
    height: 37px;
    position: absolute;
    right: 10px;
    top: -65px;
}

.vip-btn {
    position: absolute;
    bottom: 50px;
    width: 418px;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 97px;
    height: 77px;
    background: linear-gradient(to right,#0089ff,#005bac);
    box-shadow: 0px 6px 21px 0px rgba(0, 137, 255, 0.4);
    border-radius: 39px;
    cursor: pointer;
}

.vip-btn>span {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
}
</style>